import React from 'react';
import { useTranslation } from 'react-i18next';

// Link "Pular para o conteúdo" (WCAG 2.4.1): o primeiro item do Tab. Fica
// fora da tela até receber foco (Acessibilidade.css). Leva ao conteúdo da
// página — o miolo do MainLayout, depois do menu lateral, quando houver; senão
// o <main> do App.
const PularParaConteudo = () => {
  const { t } = useTranslation('common');

  const pular = (e) => {
    const alvo = document.getElementById('conteudo-pagina') || document.getElementById('conteudo-principal');
    if (!alvo) return;
    e.preventDefault();
    if (!alvo.hasAttribute('tabindex')) alvo.setAttribute('tabindex', '-1');
    alvo.focus();
    alvo.scrollIntoView?.({ block: 'start' });
  };

  return (
    <a className="pular-conteudo" href="#conteudo-principal" onClick={pular}>
      {t('a11y.skipToContent')}
    </a>
  );
};

export default PularParaConteudo;
